import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useMemo, useState, useCallback, useEffect } from 'react';
import Downshift from 'downshift';
import '../../utils/assertions.es.js';
import { warn, runIfFn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, shadow, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { List } from '../List/List.es.js';
import { Styled } from './styled.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var defaultGetItemsLabel = function defaultGetItemsLabel(item) {
  return "" + item;
};

var DefaultComponent = function DefaultComponent(_ref) {
  var _ref$getItemsLabel = _ref.getItemsLabel,
      getItemsLabel = _ref$getItemsLabel === void 0 ? defaultGetItemsLabel : _ref$getItemsLabel,
      children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, getItemsLabel(children))
  );
};

var DefaultNoResultsComponent = function DefaultNoResultsComponent(_ref2) {
  var children = _ref2.children;
  return (
    /* @__PURE__ */
    React.createElement(Box, {
      p: "md"
    }, children)
  );
};

var Popover = styled(Box).withConfig({
  componentId: "hg7d0f-0"
})(["background-color:", ";box-shadow:", ";overflow-y:auto;width:100%;margin:0;border-top:0;position:absolute;z-index:1000;list-style:none;padding:0;left:0;border-radius:0;"], themeMode({
  light: palette("neutral.0"),
  dark: palette("neutral.800")
}), shadow("3"));

var getGroups = function getGroups(groupBy, items) {
  return groupBy ? Array.from(new Set(items.map(function (item) {
    return groupBy(item);
  }))) : [""];
};

var getItemFromItemWithIndex = function getItemFromItemWithIndex(item) {
  return item.item;
};

var getItemsByGroup = function getItemsByGroup(groupBy, groups, items) {
  return groups.map(function (group) {
    return {
      group: group,
      items: groupBy ? items.filter(function (item) {
        return groupBy(getItemFromItemWithIndex(item)) === group;
      }) : items
    };
  });
};

var Autocomplete = function Autocomplete(_a) {
  var _b = _a,
      children = _b.children,
      id = _b.id,
      _b$items = _b.items,
      items = _b$items === void 0 ? [] : _b$items,
      onChange = _b.onChange,
      _b$initialSelectedIte = _b.initialSelectedItem,
      initialSelectedItem = _b$initialSelectedIte === void 0 ? [] : _b$initialSelectedIte,
      _b$initialInputValue = _b.initialInputValue,
      initialInputValue = _b$initialInputValue === void 0 ? "" : _b$initialInputValue,
      singleValueComponent = _b.singleValueComponent,
      _b$itemComponent = _b.itemComponent,
      ItemComponent = _b$itemComponent === void 0 ? DefaultComponent : _b$itemComponent,
      _b$noResultsComponent = _b.noResultsComponent,
      NoResultsComponent = _b$noResultsComponent === void 0 ? DefaultNoResultsComponent : _b$noResultsComponent,
      staticBottomComponent = _b.staticBottomComponent,
      _b$openOnFocus = _b.openOnFocus,
      openOnFocus = _b$openOnFocus === void 0 ? false : _b$openOnFocus,
      groupBy = _b.groupBy,
      _b$getItemsLabel = _b.getItemsLabel,
      getItemsLabel = _b$getItemsLabel === void 0 ? defaultGetItemsLabel : _b$getItemsLabel,
      downshiftProps = _b.downshiftProps,
      menuProps = _b.menuProps,
      props = __objRest(_b, ["children", "id", "items", "onChange", "initialSelectedItem", "initialInputValue", "singleValueComponent", "itemComponent", "noResultsComponent", "staticBottomComponent", "openOnFocus", "groupBy", "getItemsLabel", "downshiftProps", "menuProps"]);

  warn({
    condition: true,
    message: "The Autocomplete component will be deprecated in a future version. Use ComboBox or MultiSelect."
  });
  var groups = useMemo(function () {
    return getGroups(groupBy, items);
  }, [items, groupBy]);
  var itemsWithIndexes = useMemo(function () {
    return items.map(function (item, index) {
      return {
        item: item,
        index: groups.length + index
      };
    });
  }, [items, groups.length]);
  var itemsByGroup = useMemo(function () {
    return getItemsByGroup(groupBy, groups, itemsWithIndexes);
  }, [groupBy, groups, itemsWithIndexes]);

  var _useState = useState(itemsByGroup),
      inputItems = _useState[0],
      setInputItems = _useState[1];

  var _useState2 = useState(initialSelectedItem),
      selectedItems = _useState2[0],
      setSelectedItems = _useState2[1];

  var _useState3 = useState(initialInputValue),
      inputValue = _useState3[0],
      setInputValue = _useState3[1];

  var _useState4 = useState(),
      isSingleInput = _useState4[0],
      setIsSingleInput = _useState4[1];

  var _useState5 = useState(false),
      isSingleValueComponentVisible = _useState5[0],
      setIsSingleValueComponentVisible = _useState5[1];

  var filterItems = useCallback(function (inputValue2) {
    setInputItems(function () {
      return itemsByGroup.reduce(function (items2, groupData) {
        var filteredItems = groupData.items.filter(function (i) {
          return typeof getItemsLabel(getItemFromItemWithIndex(i)) === "string" && getItemsLabel(getItemFromItemWithIndex(i)).toLowerCase().includes(inputValue2.toLowerCase());
        });

        if (filteredItems.length !== 0) {
          return [].concat(_toConsumableArray(items2), [{
            group: groupData.group,
            items: filteredItems
          }]);
        }

        return items2;
      }, []);
    });
  }, [getItemsLabel, itemsByGroup]);
  useEffect(function () {
    filterItems(inputValue);
  }, [filterItems, inputValue, itemsByGroup]);
  useEffect(function () {
    if (initialSelectedItem.length !== 0 || initialInputValue || singleValueComponent) {
      setIsSingleValueComponentVisible(true);
    }
  }, [initialSelectedItem, initialInputValue, singleValueComponent]);
  useEffect(function () {
    if (onChange) {
      onChange(selectedItems);
    }
  }, [onChange, selectedItems]);
  useEffect(function () {
    var child = React.Children.only(children);

    if (!
    /*#__PURE__*/
    React.isValidElement(child)) {
      return;
    }

    var displayName = child.type.displayName;

    if (displayName === "Input") {
      setIsSingleInput(true);
    } else if (displayName === "ChipInput") {
      setIsSingleInput(false);
    }
  }, [children]);

  var addSelectedItem = function addSelectedItem(item) {
    if (!item) {
      return;
    }

    if (isSingleInput) {
      setSelectedItems(item);
    } else {
      setSelectedItems([].concat(_toConsumableArray(selectedItems), [item]));
      setInputValue("");
    }
  };

  var removeItem = function removeItem(item) {
    if (!Array.isArray(selectedItems)) {
      return;
    }

    setSelectedItems(function () {
      return selectedItems.filter(function (i) {
        return i !== item;
      });
    });
    setInputValue("");
  };

  var handleChange = function handleChange(selectedItem) {
    addSelectedItem(selectedItem);

    if (singleValueComponent) {
      setIsSingleValueComponentVisible(true);
    }
  };

  var handleInputValueChange = function handleInputValueChange(inputValue2) {
    if (inputValue2 === void 0) {
      inputValue2 = "";
    }

    setInputValue(inputValue2);
    filterItems(inputValue2);
  };

  var renderInputChild = function renderInputChild(inputProps) {
    var child = React.Children.only(children);

    if (!
    /*#__PURE__*/
    React.isValidElement(child)) {
      return (
        /* @__PURE__ */
        React.createElement(React.Fragment, null)
      );
    }

    var handleOnRemove = function handleOnRemove(item) {
      var _a2, _b2;

      removeItem(item);
      (_b2 = (_a2 = child.props).onRemove) == null ? void 0 : _b2.call(_a2, item);
    };

    var handleOnFocus = function handleOnFocus(e) {
      var _a2, _b2, _c;

      if (singleValueComponent) {
        setIsSingleValueComponentVisible(false);
      }

      if (openOnFocus) {
        (_a2 = inputProps.onFocus) == null ? void 0 : _a2.call(inputProps, e);
      }

      (_c = (_b2 = child.props).onFocus) == null ? void 0 : _c.call(_b2, e);
    };

    var handleOnBlur = function handleOnBlur(e) {
      var _a2;

      if (inputProps.value && singleValueComponent) {
        setIsSingleValueComponentVisible(true);
      }

      (_a2 = inputProps.onBlur) == null ? void 0 : _a2.call(inputProps, e);
    };

    var handleInputRef = function handleInputRef(node) {
      if (!node) {
        return;
      }

      if (!!inputValue && singleValueComponent && isSingleValueComponentVisible) {
        node.style.opacity = "0";
      } else {
        node.style.opacity = "1";
      }
    };

    var displayName = child.type.displayName;

    if (displayName === "Input") {
      return (
        /* @__PURE__ */
        React.createElement(React.Fragment, null, !!inputProps.value && isSingleValueComponentVisible &&
        /* @__PURE__ */
        React.createElement(Styled.SingleValueComponentContainer, null, runIfFn(singleValueComponent, {
          value: inputProps.value
        })),
        /*#__PURE__*/
        React.cloneElement(child, __spreadProps(__spreadValues(__spreadValues({}, child.props), inputProps), {
          ref: handleInputRef,
          onFocus: handleOnFocus,
          onBlur: handleOnBlur
        })))
      );
    }

    if (displayName === "ChipInput") {
      return (
        /*#__PURE__*/
        React.cloneElement(child, __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues({
          getItemsLabel: getItemsLabel
        }, child.props), inputProps), {
          onFocus: handleOnFocus
        }), !(downshiftProps == null ? void 0 : downshiftProps.selectedItem) ? {
          values: selectedItems
        } : {}), {
          onRemove: handleOnRemove
        }))
      );
    }

    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null)
    );
  };

  return (
    /* @__PURE__ */
    React.createElement(Downshift, __spreadValues({
      onChange: handleChange,
      onInputValueChange: handleInputValueChange,
      initialSelectedItem: initialSelectedItem,
      initialInputValue: initialInputValue,
      inputValue: inputValue,
      inputId: id,
      itemToString: getItemsLabel
    }, downshiftProps), function (_ref3) {
      var isOpen = _ref3.isOpen,
          highlightedIndex = _ref3.highlightedIndex,
          getRootProps = _ref3.getRootProps,
          getMenuProps = _ref3.getMenuProps,
          getItemProps = _ref3.getItemProps,
          getInputProps = _ref3.getInputProps,
          openMenu = _ref3.openMenu,
          closeMenu = _ref3.closeMenu;
      return (
        /* @__PURE__ */
        React.createElement(Styled.Autocomplete, __spreadValues(__spreadValues({}, getRootProps()), props), renderInputChild(__spreadValues({}, getInputProps())),
        /* @__PURE__ */
        React.createElement(Popover, __spreadValues({}, getMenuProps()), isOpen &&
        /* @__PURE__ */
        React.createElement(React.Fragment, null,
        /* @__PURE__ */
        React.createElement(Box, {
          maxHeight: (menuProps == null ? void 0 : menuProps.maxHeight) || 180,
          overflow: "auto"
        }, inputItems.length === 0 ?
        /* @__PURE__ */
        React.createElement(NoResultsComponent, null, "No results match this query") :
        /* @__PURE__ */
        React.createElement(List, null, inputItems.map(function (groupData, index) {
          return (
            /* @__PURE__ */
            React.createElement(React.Fragment, {
              key: index
            }, groupData.group &&
            /* @__PURE__ */
            React.createElement(List.Subheader, __spreadValues({}, getItemProps({
              item: null,
              index: index
            })), groupData.group), groupData.items.map(function (item) {
              return (
                /* @__PURE__ */
                React.createElement(List.Item, __spreadValues({
                  key: item.index,
                  isSelected: item.index === highlightedIndex
                }, getItemProps({
                  item: getItemFromItemWithIndex(item),
                  index: item.index
                })),
                /* @__PURE__ */
                React.createElement(ItemComponent, {
                  getItemsLabel: getItemsLabel
                }, getItemFromItemWithIndex(item)))
              );
            }))
          );
        }))), staticBottomComponent &&
        /* @__PURE__ */
        React.createElement("div", __spreadValues({}, getItemProps({
          item: null,
          index: -1
        })),
        /* @__PURE__ */
        React.createElement(Styled.Divider, null), runIfFn(staticBottomComponent, {
          inputValue: inputValue,
          closeMenu: closeMenu
        })))))
      );
    })
  );
};

Autocomplete.displayName = "Autocomplete";
export { Autocomplete };